import { Button } from '@profgeosoft-ui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useStore } from 'src/store';
import { PlanVersionType } from 'src/store/comparison/types';
import {
  GOPLAN_DRILLING_CARPET_GRAPH_EDIT,
  GOPLAN_DRILLING_CARPET_GRAPH_READ,
  GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_EDIT,
  GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_READ,
  GOPLAN_DRILLING_CARPET_WELL_CLUSTER_ACCESS_READ,
  GOPLAN_DRILLING_CARPET_WELLS_ACCESS_EDIT,
  GOPLAN_DRILLING_CARPET_WELLS_ACCESS_READ,
} from 'src/store/roles-store/roles';

import styles from './styles.module.scss';

export const DrillingCarpetNavigation = observer(function DrillingCarpetNavigation() {
  const { t } = useTranslation('drillingCarpet');
  const navigate = useNavigate();
  const { rolesStore, planVersionsService, editing } = useStore();
  const location = useLocation();

  const navItems = useMemo(() => {
    const isPublicDraft = planVersionsService.currentPlanVersion?.data.versionType === PlanVersionType.public;
    const items: { name: string; to: string; disabled?: boolean }[] = [];

    if (
      rolesStore.hasAccess([
        GOPLAN_DRILLING_CARPET_GRAPH_READ,
        GOPLAN_DRILLING_CARPET_GRAPH_EDIT,
        GOPLAN_DRILLING_CARPET_WELL_CLUSTER_ACCESS_READ,
      ])
    ) {
      items.unshift({
        name: 'Nav.schedule',
        to: 'schedule',
      });
    }

    if (rolesStore.hasAccess([GOPLAN_DRILLING_CARPET_WELLS_ACCESS_READ, GOPLAN_DRILLING_CARPET_WELLS_ACCESS_EDIT])) {
      items.unshift({
        name: 'Nav.wells',
        to: 'wells',
      });
    }

    if (
      rolesStore.hasAccess([
        GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_READ,
        GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_EDIT,
      ])
    ) {
      items.unshift({
        name: 'Nav.wellPadPreparation',
        to: 'wellPadPreparation',
        disabled: editing.isEditing || !isPublicDraft,
      });
    }

    return items;
  }, [editing.isEditing, planVersionsService.currentPlanVersion?.data.versionType, rolesStore]);

  return (
    <div className={styles.wrapper}>
      {navItems.map((nav) => {
        const isActive = location.pathname.includes(nav.to);

        return (
          <Button
            key={nav.to}
            className={clsx(styles.navWrapper, !isActive && styles.navWrapper__inactive)}
            variant="flat"
            disabled={nav.disabled}
            onClick={() => navigate(nav.to)}
          >
            <h3 className={clsx(styles.navTitle, styles.h3, !isActive && styles.navTitle__inactive)}>{t(nav.name)}</h3>
          </Button>
        );
      })}
    </div>
  );
});
